import React from 'react';
import '../components-css/about-me.scss'
import MiniHeaders from "./mini-headers";

const AboutMe = () => {
    return (
        <div className={'blocks-wrapper'}>
            <MiniHeaders headerName={'Իմ Մասին'}/>
            <div>
                <p>Ողջու՜յն ես Միլենան եմ։</p>
                <br/>
                <p>Արդեն 2 տարի է ինչ գործունեություն եմ ծավալում Wildberries մարկետփլեյսի շրջանակներում՝ հանդես գալով և՛ որպես վաճառող, և՛ որպես մենեջեր։</p>
                <br/>
                <p>Սեփական խանութիս շրջանառությունը ամսական գերազանցում է <em><b>3</b></em> մլն ռուբլին:</p>
                <br/>
                <p>2 տարվա ընթացքում ձեռք բերած գիտելիքներով ու բազմաթիվ վերլուծությունների արդյունքում ձևավորված փորձով հասցրել եմ կիսվել ավելի քան 700 ուսանողների հետ, որոնց մեծ մասն իրենց գործունեությունն են շարունակել ծավալել այս ոլորտում՝ բարելավելով իրենց կյանքը։
                </p>
            </div>
            <div className={'about-me-img'}/>
        </div>
    );
};

export default AboutMe;
